import {
  calendarTheme,
  Colors,
  purple1Shadow,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import type { CalendarProps } from 'react-native-calendars';
import { Calendar } from 'react-native-calendars';
import { Portal } from 'react-native-paper';

type Props = {
  isVisible: boolean;
  onClose: () => void;
  position?: {
    top: number;
    left: number;
  };
} & CalendarProps;

export const CalendarModal = ({
  isVisible,
  onClose,
  position,
  ...calendarProps
}: Props) => {
  const styles = useDynamicStyles(createStyles, { position });

  if (!isVisible) return null;

  return (
    <Portal>
      <Pressable style={styles.backdrop} onPress={onClose}>
        <Pressable
          onPress={(e) => {
            // Prevent the backdrop from closing when clicking on the calendar
            e.stopPropagation();
          }}
        >
          <Calendar
            hideExtraDays={true}
            enableSwipeMonths={true}
            disableAllTouchEventsForDisabledDays={true}
            markingType="multi-dot"
            style={styles.calendarContainer}
            theme={calendarTheme}
            {...calendarProps}
          />
        </Pressable>
      </Pressable>
    </Portal>
  );
};

export const GET_CALENDAR_MODAL_WIDTH = (isMobile: boolean) =>
  isMobile ? 280 : 400;

const createStyles = ({ isMobile, position }: WithResponsive<Props>) =>
  StyleSheet.create({
    backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
    },
    calendarContainer: {
      position: 'absolute',
      overflow: 'visible',
      top: position?.top ?? (isMobile ? 55 + 54 : 55 + 76),
      left: position?.left,
      alignSelf: position?.left ? undefined : 'center',
      zIndex: 2,
      backgroundColor: Colors.purple0,
      borderRadius: 16,
      width: GET_CALENDAR_MODAL_WIDTH(isMobile),
      paddingBottom: 8,
      ...purple1Shadow,
    },
  });
